/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React, { useState } from "react";
import { SNMPDevice } from "@/api/snmp";
import { SNMPPortsTab } from "./tabs/SNMPPortsTab";
import { SNMPOverviewTab } from "./tabs/SNMPOverviewTab";

interface SNMPDeviceDetailsTabsProps {
  device: SNMPDevice;
}

type View = "ports" | "overview";

export const SNMPDeviceDetailsTabs: React.FC<SNMPDeviceDetailsTabsProps> = ({ device }) => {
  const [view, setView] = useState<View>("ports");
  return (
    <>
      <div className="sv-tabs" role="tablist">
        {(
          [
            ["ports", "Ports"],
            ["overview", "Overview"],
          ] as const
        ).map(([id, label]) => (
          <button key={id} role="tab" aria-selected={view === id} className={`gh-btn${view === id ? " gh-btn--on" : ""}`} onClick={() => setView(id)}>
            {label}
          </button>
        ))}
      </div>
      {view === "ports" ? <SNMPPortsTab device={device} /> : <SNMPOverviewTab device={device} />}
    </>
  );
};
